import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.9646 9.07133L8.5946 5.75533C8.26527 5.43133 7.7326 5.43133 7.40326 5.75533L4.0346 9.07133C3.70526 9.39466 3.70526 9.91933 4.0346 10.2433C4.3626 10.5673 4.8966 10.5673 5.2246 10.2433L7.99993 7.514L10.7733 10.2433C11.1026 10.5673 11.6353 10.5673 11.9646 10.2433C12.1286 10.082 12.2106 9.86933 12.2106 9.65733C12.2106 9.44533 12.1286 9.23266 11.9646 9.07133Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}